import React from 'react'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.min.css'

function Toastify() {
  return <ToastContainer position="bottom-right" icon={false} theme="colored" />
}

export default Toastify
